<!--테스트 http://localhost:7777/orderDetail?order_id=1490&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtZW1iZXJfbm8iOiIxNjM0NjIyMTIzMDkwIiwiZW1haWwiOiIiLCJuYW1lIjoi6rOg66y0IiwidHlwZSI6InBob25lIiwicHJvZmlsZSI6bnVsbCwidXNlcl90eXBlIjoi7J2867CYIiwiaWF0IjoxNjM0NjIyMTIzLCJleHAiOjE3MjEwMjIxMjMsImlzcyI6Ii5vaC1iYWIuY29tIiwic3ViIjoidXNlckluZm8ifQ.3u8cGhlYDwHzwRZJv4XR4tfrk2m-15-y-BtknTUJZqs-->

<template>
  <section class="mobile_wrap">
    <div v-if="!isLoading"></div>
    <div v-else class="order__content">
      <div class="order__details">
        <p>주문완료</p>
        <ul class="product_list">
          <li>
            <dl class="item_subinfo">
              <dd>주문번호</dd>
              <dd v-html="order.id" />
            </dl>
          </li>
          <li>
            <dl class="item_subinfo">
              <dd>주문시간</dd>
              <dd>
                {{ order.ago }}
              </dd>
              <!-- <dd>2021-02-02 14:06</dd> -->
            </dl>
          </li>
        </ul>
      </div>
      <div class="order__details">
        <p>주문내역</p>
        <ul class="product_list">
          <li v-for="item in order.products">
            <dl class="item_subinfo item__price">
              <dd class="ui-item-name" v-html="item.name" />
              <dd class="ui-qty">수량 {{ item.qty }}</dd>
              <dd v-html="item.price.toLocaleString('ko-KR') + '원'" />
            </dl>
          </li>
        </ul>
      </div>
      <div class="order__details">
        <p>결제내역</p>
        <ul class="product_list">
          <li>
            <dl class="item_subinfo item__price">
              <dd>주문 금액</dd>
              <dd>{{ price.toLocaleString("ko-KR") }}원</dd>
            </dl>
          </li>
          <li>
            <dl class="item_subinfo item__price">
              <dd>배송비</dd>
              <dd>
                {{
                  delivery && delivery.price
                    ? "+" + delivery.price.toLocaleString("ko-KR")
                    : 0
                }}원
              </dd>
            </dl>
          </li>
          <li>
            <dl class="item_subinfo item__price">
              <dd>CRC 사용</dd>
              <dd>
                {{
                  order.spoon ? "-" + order.spoon.toLocaleString("ko-KR") : 0
                }}원
              </dd>
            </dl>
          </li>
          <li>
            <dl class="item_subinfo item__price">
              <dd>쿠폰</dd>
              <dd>
                {{
                  order.coupon
                    ? `${
                        order.coupon.name
                      } -${order.coupon.discount.toLocaleString("ko-KR")}원`
                    : "없음"
                }}
              </dd>
            </dl>
          </li>
          <li class="amount__list">
            <dl class="item_subinfo item__price">
              <dd>최종결제금액</dd>
              <dd>
                <span>{{ order.amount.toLocaleString("ko-KR") }}</span
                >원
              </dd>
            </dl>
          </li>
          <!-- <li>
                        <dl class="item_subinfo item__price">
                            <dd>결제방식</dd>
                            <dd>예치금 차감</dd>
                        </dl>
                    </li> -->
        </ul>
      </div>
      <hr />
      <!-- 배송지 정보-->
      <div class="order__details mt0" v-if="order.delivery=='delivery'">
        <p>배송 정보</p>
        <ul class="product_list address__info">
          <li>
            <dl class="item_subinfo">
              <dd>받는분</dd>
              <dd v-html="delivery.end_address.name" />
            </dl>
          </li>
          <li>
            <dl class="item_subinfo">
              <dd>연락처</dd>
              <dd v-html="delivery.end_address.phone" />
            </dl>
          </li>
          <li>
            <dl class="item_subinfo">
              <dd>주소</dd>
              <dd>
                {{ delivery.end_address.place_name ? '('+delivery.end_address.place_name+')' : '' }}
                {{ delivery.end_address.road_address_name?delivery.end_address.road_address_name: delivery.end_address.address_name }}
                {{ delivery.end_address.address_detail }}
              </dd>
            </dl>
          </li>
          <!--
                    <li>
                        <dl class="item_subinfo">
                            <dd>요청사항</dd>
                            <dd>[도로명] 경기도 성남시 분당구 성남대로 <br />343번길 12-8, 4층<br />[안전배달] 문 앞에 놓고 문자주세요</dd>
                        </dl>
                    </li>
                    -->
        </ul>
      </div>
      <!-- 직접수령 일시 -->
      <div v-if="order.delivery=='direct'" class="order__details">
        <p>직접수령</p>
      </div>
      <!-- 픽업지 정보-->
      <div
        class="order__details"
        v-if="order.delivery=='direct'"
      >
        <ul class="product_list address__info">
          <li>
            <dl class="item_subinfo">
              <dd>상호명</dd>
              <dd v-html="order.address.name" />
            </dl>
          </li>
          <li>
            <dl class="item_subinfo">
              <dd>연락처</dd>
              <dd v-html="order.address.phone" />
            </dl>
          </li>
          <li>
            <dl class="item_subinfo">
              <dd>주소</dd>
              <dd>
                {{ order.address.place_name ? '(' +order.address.place_name + ')' : '' }}
                {{ order.address.road_address_name ? order.address.road_address_name : order.address.address_name }}
                {{ order.address.address_detail }}
              </dd>
            </dl>
          </li>
        </ul>
      </div>
      <!-- 택배 정보 -->
      <hr v-if="post" />
      <div class="order__details" v-if="post">
        <p>택배 정보</p>
        <ul class="product_list address__info">
          <li>
            <dl class="item_subinfo" v-if="delivery && delivery.post_number">
              <dd>송장번호</dd>
              <dd v-html="delivery.post_number" />
            </dl>
          </li>
          <li>
            <dl class="item_subinfo" v-if="post.carrier">
              <dd>배송업체</dd>
              <dd v-html="post.carrier.name" />
            </dl>
          </li>
          <li>
            <dl class="item_subinfo" v-if="post.state">
              <dd>배송상태</dd>
              <dd v-html="post.state.text" />
            </dl>
          </li>
          <!--
                    <li>
                        <dl class="item_subinfo">
                            <dd>요청사항</dd>
                            <dd>[도로명] 경기도 성남시 분당구 성남대로 <br />343번길 12-8, 4층<br />[안전배달] 문 앞에 놓고 문자주세요</dd>
                        </dl>
                    </li>
                    -->
        </ul>
        <ul class="post_section timeline_list">
          <li  class="step_item" v-for="(item, index) in post.progresses" :key="index">
            <div class="delivery_info">
                <span class="location">{{item.location.name}}</span>
                <span class="state">{{item.status.text}}</span>
            </div>
            <span class="date">{{item.ui_time}}</span>
            <!-- {{item}} -->
          </li>
        </ul>
      </div>

    </div>
    <!-- 
        <DaumPostCode :open="showDaumPostCode" @selected="onAddressSelected" />
        <loading v-show="loading"/> 
        -->
  </section>
</template>

<script>
// import client from '../client/client'
// import { PGS } from '../order/constants';
// import Utils from '../order/utils';
// import Loading from '../components/Loading'
// import DaumPostCode from '../components/DaumPostCode'
import client from "../client/client";
import { sweettrackerKey } from "../order/importpay";
import { useRoute } from "vue-router";

export default {
  name: "orderDetail",
  data: () => ({
    isLoading: false,
    order: {},
    delivery: {},
    post: null,
    price: 0, //제품 가격
  }),
  components: {},
  methods: {
    async update() {
      const route = useRoute()
      const { query } = route
      // alert(JSON.stringify(query, null, 2));
      client.updateToken(query);
      // alert(query.order_id);
      
      let order = await client.get(`/api/order/detail/${query.order_id}`);
      console.log(order);
      this.order = order.order;
      this.delivery = order.delivery;
      
      this.order.products.map((item) => {
        this.price = this.price + item.price * item.qty;
      });
      console.log('aaaa');
      if(this.order.delivery != "direct") {
        console.log('bbbb');
        if(order.delivery.delivery_type == '사업주배송' && order.delivery && order.delivery.post_number && order.delivery.post_id){
          console.log('dddd');
          let postData = await client.get(`/api/delivery/post?post_number=${order.delivery.post_number}&post_id=${order.delivery.post_id}`);
          console.log('postData => ', postData);
          if(postData && postData.r) {
            this.post = postData.result;
          }
        }
      }
      console.log('cccc');
      this.isLoading = true;
    },
  },
  async mounted() {
    this.update();
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/icon.scss";
.post_section{
  margin:10px 0 0;
  padding:12px 16px;
  list-style: none;
  display: flex;
  flex-flow: column-reverse;
  .step_item{
    &:first-child{
      &::before{
        display: none;
      }
    }
    &:last-child{
      &::after{
        background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle fill='%23F2632A' cx='10' cy='10' r='10'/%3E%3Cpath d='M14.148 6.303a.75.75 0 0 1 1.264.8l-.06.094-5.198 7a.75.75 0 0 1-1.067.142l-.077-.07-3.802-3.982a.75.75 0 0 1 1.002-1.11l.082.074 3.187 3.337 4.669-6.285Z' fill='%23FFF' fill-rule='nonzero'/%3E%3C/g%3E%3C/svg%3E");
        background-color:none;
        border:0;
        width:20px;
        height:20px;
        left:-6px;
        top:2px;
      }
    }
  }
  .step_item:before {
    position: absolute;
    left: 4px;
    top: 8px;
    bottom: -6px;
    border-left: 1px solid #d7dfe8;
    content: '';
  }

  .step_item:after {
    position: absolute;
    top: 5px;
    left: 1px;
    display: inline-block;
    width: 0.438rem;
    height: 0.438rem;
    vertical-align: top;
    background-color: #fff;
    border: 2px solid #d7dfe8;
    border-radius: 50%;
    content: '';
  }
  .delivery_info{
    position: relative;
    .state:before{
      display: inline-block;
      margin: 5px 6px 0 6px;
      vertical-align: top;
      width: 1px;
      height: 12px;
      background-color: #ccc;
      content: '';
    }
  }
  .step_item{
    padding:0 35px 15px 20px;
    position:relative;
  }
}
.ui-item-name{
  flex:1;
}
.ui-qty{
  padding:0 16px 0 8px;
}
.mt28 {
  margin-top: 28px !important;
}
.mt0 {
  margin-top: 0 !important;
}
body {
  background-color: #eee !important;
}
hr {
  margin: 30px 0;
  width: 100%;
  height: 10px;
  background: #f4f4f4;
  border: 0;
}
.order__details {
  margin: 28px 16px 0;
  &:first-child,
  &:last-child {
    margin-top: 0;
  }
  p {
    font-size: 14px;
    color: #343434;
    padding: 0;
    margin: 0 0 10px;
    font-weight: bold;
  }
  .amount__list {
    margin-top: 12px !important;
    padding-top: 12px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }
  .product_list {
    padding: 16px 12px;
    margin: 0;
    background: #f4f4f4;
    border-radius: 6px;
    list-style: none;
    li {
      margin-top: 10px;
      &:first-child {
        margin-top: 0;
      }
    }
    .item_subinfo {
      display: flex;
      margin: 0px;
      flex-wrap: wrap;
      word-break: break-all;
      dd {
        font-size: 14px;
        color: #343434;
        margin: 0;
        &:first-child {
          flex-basis: 90px;
        }
      }
      &.item__price {
        dd {
          span {
            color: #f2632a;
            font-weight: bold;
          }
          &:last-child {
            margin-left: auto;
          }
        }
      }
    }
    &.address__info {
      dd {
        &:first-child {
          font-weight: bold;
        }
      }
    }
  }
}

.order__content {
  padding: 30px 0;
  width: 100%;
  flex-grow: 1;
}
.mobile_wrap {
  max-width: 640px;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
  > div {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
}
</style>
